import React, { Component } from "react";
import Toast from "react-bootstrap/Toast";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

import ArrowBack from "./icons/topbar/ArrowBack";
import Save from "./icons/topbar/Save";

export default class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSaveNotification: false,
      showAddToPlannerModal: false,
    };
  }

  render() {
    let hideSaveTabs = ["crop", "straighten", "retouch"];
    let showSave = hideSaveTabs.indexOf(this.props.currentTab) == -1;
    return (
      <>
        <div className="top-bar d-flex justify-content-between">
          <a
            href="javascript:void(0)"
            onClick={() => {
              window.ReactNativeWebView.postMessage("go-back");
            }}
          >
            <ArrowBack className="" />
          </a>

          {showSave && (
            <a
              href="javascript:void(0)"
              onClick={() => {
                this.props.onSaveClicked();
              }}
            >
              {this.props.isSaving ? (
                <div className="position-relative d-inline-block">
                  <Spinner animation="border" role="status" />
                  <small className="position-absolute pb-1 top-50 start-50 translate-middle text-small">
                    {this.props.progress > 0 ? this.props.progress + "" : ""}
                  </small>
                </div>
              ) : (
                this.props.currentTab !== "crop" && <Save className="" />
              )}
            </a>
          )}
        </div>

        {this.state.showSaveNotification && (
          <Toast
            className="p-top"
            // onClick={() => {
            //     this.setState(prevState => ({
            //         showSaveNotification: !prevState.showSaveNotification
            //     }));
            // }}
          >
            <Toast.Body>
              <div className="row m-0 align-items-center">
                <div className="col">Your item is saved</div>
                <div className="col-auto p-0">
                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={() => {
                      this.setState((prevState) => ({
                        showSaveNotification: !prevState.showSaveNotification,
                        showAddToPlannerModal: !prevState.showAddToPlannerModal,
                      }));
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Toast.Body>
          </Toast>
        )}

        <Modal
          className="p-btm"
          show={this.state.showAddToPlannerModal}
          onHide={() => {
            this.setState((prevState) => ({
              showAddToPlannerModal: !prevState.showAddToPlannerModal,
            }));
          }}
        >
          <Modal.Body>
            <h3 className="title">Add it to your planner</h3>
            <p className="text">
              Would you like to add this post to your planner
            </p>
            <div className="row justify-content-between my-5">
              <div className="col-auto">
                <Button
                  variant="dark"
                  onClick={() => {
                    this.setState((prevState) => ({
                      showAddToPlannerModal: !prevState.showAddToPlannerModal,
                    }));
                  }}
                >
                  Yes
                </Button>
              </div>
              <div className="col-auto">
                <Button
                  variant="dark"
                  onClick={() => {
                    this.setState((prevState) => ({
                      showAddToPlannerModal: !prevState.showAddToPlannerModal,
                    }));
                  }}
                >
                  No
                </Button>
              </div>
            </div>
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="doNotAskAgain"
              />
              <label className="form-check-label" htmlFor="doNotAskAgain">
                Don't ask me again
              </label>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
